/** Reabre a nota lançada para edição; a justificativa vai para o histórico. */
export class NFeEntradaReabrirRequest {
  justificativa = '';
}
